import * as f from "react";
import { assignRef as r } from "./assignRef.js";
import { useCallbackRef as s } from "./useRef.js";
var m = typeof window < "u" ? f.useLayoutEffect : f.useEffect,
  c = /* @__PURE__ */new WeakMap();
function v(e, i) {
  var n = s(i || null, function (t) {
    return e.forEach(function (o) {
      return r(o, t);
    });
  });
  return m(function () {
    var t = c.get(n);
    if (t) {
      var o = new Set(t),
        u = new Set(e),
        l = n.current;
      o.forEach(function (a) {
        u.has(a) || r(a, null);
      }), u.forEach(function (a) {
        o.has(a) || r(a, l);
      });
    }
    c.set(n, e);
  }, [e]), n;
}
export { v as useMergeRefs };